// index.tsx
// ThemeProvider component for applying EHR-specific theming to the application.
// Wraps children in the appropriate theme provider based on the current EHR context.

import { ContextDetails } from "ehr-launcher-lib";
import ForgeProvider from "@components/ForgeProvider";

/**
 * Props for the ThemeProvider component
 * @property children - The React children to render
 * @property ehr - The current EHR context (e.g., 'athena', 'cerner')
 */
const ThemeProvider = ({
  children,
  ehr,
}: {
  children: React.ReactNode;
  ehr: ContextDetails["currentEHR"];
}) => {
  /**
   * Maps EHR context to the appropriate theme provider.
   */
  const ThemeMapper = {
    athena: <ForgeProvider>{children}</ForgeProvider>,
    cerner: <div>{children}</div>,
  };

  return ThemeMapper[ehr];
};

export default ThemeProvider;
